import React, { useState } from "react";
import "./styles.css";
import { AiOutlineSearch } from "react-icons/ai";
import { Collapse } from "react-collapse";
//import { NavLink } from "react-router-dom";
import SideNav from './../../../components/SideNav_RI';
import Logout from '../../../components/Button_Logout';

var _id = localStorage.getItem("id_agent");

export default function RI_Painel() {
    let [search, setSearch] = useState(false);
    //let [options, setOptions] = useState(false);
    
    return (
        <>
            <SideNav />
            <div id="top-RI-Cadastro">
                <Logout />
                <div style={{display:"flex", flexDirection:"row"}}>
                    <Collapse isOpened={search}>
                        <input id="RI-Cadastro-Search" placeholder="pesquisar..." />
                    </Collapse>
                    <AiOutlineSearch
                        size={"6vh"}
                        onClick={() =>
                            setSearch(!search)
                        }
                        id="Icon-Search-RI-Cadastro"
                    />
                </div>
            </div>
            <div id="main-RI-Painel">
                <div id="actions-RI-Painel">
                    <p id="RI-Painel">Ações</p>
                    <hr id="divider-RI-Painel" />
                    <div id="collapsed-RI_Painel">
                        <a href={"/RI_PacientesLista/"+ _id}><button id="option-RI-Painel">Lista de pacientes</button></a>                      
                        <a href={"/RI_Consulta/"+ _id}><button id="option-RI-Painel">Consultas</button></a>
                        <a href={"/RI_Perfil/"+ _id}><button id="option-RI-Painel">Perfil</button></a>
                    </div>
                </div>
            </div>
        </>
    );
}
